import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../common/components/base.component';

@Component({
    selector: 'app-customer-waiting',
    templateUrl: './customer-waiting.component.html',
    styleUrl: './customer-waiting.component.scss',
    standalone: false
})
export class CustomerWaitingComponent extends BaseComponent implements OnInit {

  success = false;
  cancel = false;
  activatedRoute = inject(ActivatedRoute);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.add(this.activatedRoute.queryParams.subscribe(params => {
      if (params['cn'] === 'true') {
        this.cancel = true;
      } else {
        this.success = true;
      }
    }))
  }

}
